import React, { useState } from 'react';
import { TagIcon, CheckIcon, SparklesIcon } from 'lucide-react';
interface BundleDealsProps {
  product: {
    price: number;
  };
}
export function BundleDeals({
  product
}: BundleDealsProps) {
  const [selectedOption, setSelectedOption] = useState(1);
  const bundleOptions = [{
    pieces: 1,
    pricePerPiece: product.price,
    totalPrice: product.price,
    discount: 0,
    label: 'Standard price',
    color: 'from-gray-100 to-gray-50',
    iconBg: 'bg-gray-100',
    iconColor: 'text-gray-600',
    badgeBg: 'bg-gray-500'
  }, {
    pieces: 3,
    pricePerPiece: product.price * 0.9,
    totalPrice: product.price * 0.9 * 3,
    discount: 10,
    label: 'SAVE 10%',
    color: 'from-blue-100 to-blue-50',
    iconBg: 'bg-gradient-to-br from-blue-500 to-blue-600',
    iconColor: 'text-white',
    badgeBg: 'bg-gradient-to-r from-orange-500 to-orange-600',
    popular: true
  }, {
    pieces: 5,
    pricePerPiece: product.price * 0.85,
    totalPrice: product.price * 0.85 * 5,
    discount: 15,
    label: 'SAVE 15%',
    color: 'from-sage-light to-white',
    iconBg: 'bg-brand',
    iconColor: 'text-white',
    badgeBg: 'bg-gradient-to-r from-red-500 to-red-600',
    bestValue: true
  }];
  return <div className="bg-white rounded-2xl border-2 border-gray-200 overflow-hidden" data-id="element-5349" data-mp="3daii6m6scq1d">
      {/* Header with gradient and sparkle effect */}
      <div className="bg-gradient-to-r from-[#1E2B55] via-[#2a3a6f] to-[#1E2B55] p-4 relative overflow-hidden" data-id="element-5350" data-mp="2plfx14cy0f24">
        {/* Decorative circles */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-5 rounded-full -mr-16 -mt-16" data-id="element-5351" data-mp="2ymdvz88ixwdu"></div>
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-5 rounded-full -ml-12 -mb-12" data-id="element-5352" data-mp="2uk0yf73xl4s5"></div>
        <div className="flex items-center justify-between relative z-10" data-id="element-5353" data-mp="duc1iopjccb9">
          <div className="flex items-center gap-2 text-white" data-id="element-5354" data-mp="9ul4425i6xxr">
            <div className="bg-white bg-opacity-20 p-2 rounded-lg" data-id="element-5355" data-mp="9wearhg49i5r">
              <TagIcon className="w-5 h-5" data-id="element-5356" data-mp="32o0ewplos67g" />
            </div>
            <div data-id="element-5357" data-mp="37n3kcb5kwefy">
              <h3 className="text-base font-bold" data-id="element-5358" data-mp="37mk4czzho04k">Bundle & Save</h3>
              <p className="text-xs text-blue-100" data-id="element-5359" data-mp="3cmzg5n44gzkf">Up to 15% off</p>
            </div>
          </div>
          <SparklesIcon className="w-5 h-5 text-yellow-300 animate-pulse" data-id="element-5360" data-mp="3go1f02u4n9lv" />
        </div>
      </div>
      {/* Content */}
      <div className="p-4 bg-gradient-to-b from-gray-50 to-white" data-id="element-5361" data-mp="2jytw72kw7eln">
        <div className="space-y-2.5" data-id="element-5362" data-mp="2ox54v9zgbj2a">
          {bundleOptions.map(option => <button key={option.pieces} onClick={() => setSelectedOption(option.pieces)} className={`w-full border-2 rounded-xl p-3 transition-all duration-300 transform hover:scale-[1.02] relative overflow-hidden ${selectedOption === option.pieces ? 'border-[#1E2B55] bg-gradient-to-r from-blue-50 to-indigo-50' : 'border-gray-200 hover:border-gray-300 bg-white hover:shadow-sm'}`} data-id="element-5363" data-mp="2our90ywy62to">
              <div className="flex items-center gap-3" data-id="element-5364" data-mp="1xpvfewdpafnv">
                {/* Icon with quantity badge */}
                <div className="relative flex-shrink-0" data-id="element-5365" data-mp="1srljuko2dd1q">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center shadow-sm ${option.iconBg}`} data-id="element-5366" data-mp="1sopi0l93i480">
                    <svg className={`w-6 h-6 ${option.iconColor}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-5367" data-mp="1jp2lacrb9mla">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" data-id="element-5368" data-mp="19y7wb0mok8w5" />
                    </svg>
                  </div>
                  {option.pieces > 1 && <div className={`absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full text-xs font-bold text-white shadow-sm ${option.pieces === 3 ? 'bg-sage' : 'bg-brand'}`} data-id="element-5369" data-mp="r1oukwe7hn9m">
                      {option.pieces}
                    </div>}
                </div>
                {/* Details */}
                <div className="flex-1 text-left" data-id="element-5370" data-mp="2mbo9kpl65zjf">
                  <div className="flex items-center justify-between mb-1.5" data-id="element-5371" data-mp="28cy9r26ytlrd">
                    <span className="font-bold text-gray-900 text-base" data-id="element-5372" data-mp="28f19idxx6t9a">
                      {option.pieces} Piece{option.pieces > 1 ? 's' : ''}
                    </span>
                    {option.discount > 0 && <span className={`${option.badgeBg} text-white text-xs font-bold px-2.5 py-0.5 rounded-full shadow-sm`} data-id="element-5373" data-mp="23du1qevs1u2m">
                        {option.label}
                      </span>}
                  </div>
                  <div className="flex items-center justify-between" data-id="element-5374" data-mp="1k4irnr69vys">
                    <span className="text-xs text-gray-600 font-medium" data-id="element-5375" data-mp="1m51759c35pfj">
                      {option.pieces === 1 ? option.label : `SAR ${option.pricePerPiece.toFixed(2)}/piece`}
                    </span>
                    <div className="text-right" data-id="element-5376" data-mp="1r3vxcwcdug9o">
                      <span className="text-lg font-bold text-red-600" data-id="element-5377" data-mp="1r2b5xfld7dg1">
                        SAR {option.totalPrice.toFixed(2)}
                      </span>
                      {option.discount > 0 && <div className="text-xs text-gray-500 line-through" data-id="element-5378" data-mp="1zy0mnbbvbjn3">
                          SAR {(product.price * option.pieces).toFixed(2)}
                        </div>}
                    </div>
                  </div>
                </div>
                {/* Checkmark */}
                <div className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 shadow-sm ${selectedOption === option.pieces ? 'bg-gradient-to-r from-[#1E2B55] to-[#2a3a6f] scale-110' : 'bg-gray-200'}`} data-id="element-5379" data-mp="kh0i91pw95p6">
                  {selectedOption === option.pieces && <CheckIcon className="w-4 h-4 text-white" data-id="element-5380" data-mp="1e4n0wlzzl74y" />}
                </div>
              </div>
            </button>)}
        </div>
      </div>
    </div>;
}